<div class="invoice" [attr.dir]="direction">
	<div class="header">
		<div class="info">
			<div class="company_info">
				<h4>{{ getCompanyName() }}</h4>
				<h5>{{ getCompanyPhone() }}</h5>
				<h5>
					<ng-container *ngIf="invoiceData?.customer_type === '6'">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'he'">ח.פ. {{ getCompanyVat() }}</span>
							<span *ngSwitchCase="'ar'">ح.ض. {{ getCompanyVat() }}</span>
							<span *ngSwitchDefault>C.R. {{ getCompanyVat() }}</span>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="invoiceData?.customer_type === '5'">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'he'">ת.ז. {{ getCompanyVat() }}</span>
							<span *ngSwitchCase="'ar'">ه.ش. {{ getCompanyVat() }}</span>
							<span *ngSwitchDefault>ID {{ getCompanyVat() }}</span>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="invoiceData?.customer_type !== '6' && invoiceData?.customer_type !== '5'">
						{{ getCompanyVat() }}
					</ng-container>
				</h5>
			</div>
		</div>

		<div>
			<div *ngIf="invoiceData?.logo_base64 || invoiceData?.company?.logo_url" class="logo">
				<img [src]="invoiceData?.logo_base64 || invoiceData?.company?.logo_url" 
					 [alt]="lang === 'ar' ? 'شعار الشركة' : lang === 'he' ? 'לוגו החברה' : 'Company Logo'" />
			</div>
		</div>

		<div>
			<img *ngIf="invoiceData?.signaturePath" 
				 [src]="invoiceData.signaturePath" 
				 style="width: 120px; height:fit-content; opacity: 0.5;">
			<h5>{{ getFormattedDate() }}</h5>
		</div>
	</div>

	<div class="invoice_detail">
		<div class="center_text__up">
			<h3>
				<ng-container [ngSwitch]="lang">
					<span *ngSwitchCase="'ar'">فاتورة ضريبية رقم</span>
					<span *ngSwitchCase="'he'">חשבונית מס מספר</span>
					<span *ngSwitchDefault>Tax Invoice No.</span>
				</ng-container>
				: {{ invoiceData?.document_number }}
			</h3>

			<span style="font-size: 12px;" *ngIf="invoiceData?.confirmation_number">
				{{ getConfirmationNumber().remainingDigits }}<span style="text-decoration: underline;">{{ getConfirmationNumber().last9Digits }}</span>
			</span>
		</div>

		<div class="info-container">
			<div class="info-item" *ngIf="invoiceData?.subtitle">
				<div class="label">
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'ar'">العنوان الفرعي</span>
						<span *ngSwitchCase="'he'">כותרת משנה</span>
						<span *ngSwitchDefault>Subtitle</span>
					</ng-container>
				</div>
				<div class="value">{{ invoiceData.subtitle }}</div>
			</div>

			<div class="info-item" *ngIf="invoiceData?.copyVersion">
				<div class="label">
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'ar'">نسخة</span>
						<span *ngSwitchCase="'he'">עותק</span>
						<span *ngSwitchDefault>Copy</span>
					</ng-container>
				</div>
				<div class="value">{{ invoiceData.copyVersion }}</div>
			</div>
		</div>
	</div>

	<div class="customer_info">
		<div class="center_text__down">
			<div style="font-size: 12px">
				<ng-container [ngSwitch]="lang">
					<span *ngSwitchCase="'he'">לכבוד:</span>
					<span *ngSwitchCase="'ar'">حضرة:</span>
					<span *ngSwitchDefault>to the honorable</span>
				</ng-container>
			</div>
			<h6>{{ getCustomerName() }}</h6>
		</div>

		<div *ngIf="getCustomerVat() && getCustomerVat() !== '0'" style="font-weight: 500; font-size: 12px;">
			<ng-container [ngSwitch]="lang">
				<span *ngSwitchCase="'en'">Customer Vat Number</span>
				<span *ngSwitchCase="'ar'">مشغل رقم</span>
				<span *ngSwitchDefault>ע.מ / ת.ז</span>
			</ng-container>
			: {{ getCustomerVat() }}
		</div>

		<div *ngIf="invoiceData?.customer_id_number">{{ invoiceData.customer_id_number }}</div>
	</div>

	<table *ngIf="(invoiceData?.lines?.length || invoiceData?.soldItems?.length)" class="table-one">
		<thead>
			<tr>
				<th>
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'en'">Item Name</span>
						<span *ngSwitchCase="'ar'">اسم الصنف</span>
						<span *ngSwitchDefault>פריט</span>
					</ng-container>
				</th>

				<th *ngIf="invoiceData?.invoice_type !== 200">
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'ar'">السعر</span>
						<span *ngSwitchCase="'he'">מחיר</span>
						<span *ngSwitchDefault>Price</span>
					</ng-container>
				</th>

				<th>
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'ar'">الكمية</span>
						<span *ngSwitchCase="'he'">כמות</span>
						<span *ngSwitchDefault>Quantity</span>
					</ng-container>
				</th>

				<th *ngIf="invoiceData?.invoice_type !== 200">
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'en'">Discount</span>
						<span *ngSwitchCase="'ar'">الخصم</span>
						<span *ngSwitchDefault>הנחה</span>
					</ng-container>
				</th>

				<th *ngIf="invoiceData?.invoice_type !== 200">
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'ar'">المجموع</span>
						<span *ngSwitchCase="'he'">סכום</span>
						<span *ngSwitchDefault>Total</span>
					</ng-container>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of (invoiceData?.lines || invoiceData?.soldItems)" style="font-weight:100;">
				<td style="text-align: start;">
					<strong>{{ item.item_name || item.product_name }}</strong><br />
					<small *ngIf="item.description" style="color: gray;">{{ item.description }}</small>
				</td>

				<td *ngIf="invoiceData?.invoice_type !== 200" style="text-align: start; font-weight: 100;">
					{{ formatNumber(item.price_per_unit || item.price) }}
				</td>

				<td style="text-align: start; font-weight: 100;">
					{{ formatNumber(item.quantity) }}
				</td>

				<td *ngIf="invoiceData?.invoice_type !== 200" style="text-align: start; font-weight: 100;">
					{{ formatNumber(item.discount) }}
				</td>

				<td *ngIf="invoiceData?.invoice_type !== 200" style="text-align: start; font-weight: 100;">
					{{ formatNumber(item.sub_total || item.total) }}
				</td>
			</tr>
		</tbody>
	</table>

	<table *ngIf="invoiceData?.invoice_type !== 200" class="second-table">
		<tr>
			<th colspan="2">
				<ng-container [ngSwitch]="lang">
					<span *ngSwitchCase="'ar'">المجموع</span>
					<span *ngSwitchCase="'he'">סה״כ</span>
					<span *ngSwitchDefault>Total</span>
				</ng-container>
			</th>
			<th class="value" colspan="2">
				{{ formatNumber(invoiceData?.amount_before_discount) }}
			</th>
		</tr>

		<tr>
			<th colspan="1">
				<ng-container [ngSwitch]="lang">
					<span *ngSwitchCase="'en'">Payment Amount Including VAT</span>
					<span *ngSwitchCase="'ar'">المبلغ المدفوع شامل الضريبة</span>
					<span *ngSwitchDefault>סה״כ לתשלום</span>
				</ng-container>
			</th>
			<th colspan="1">({{ formatNumber(getVatPercentage()) }}%)</th>
			<th class="value" colspan="2">{{ formatNumber(invoiceData?.all_vat_amount) }}</th>
		</tr>

		<tr>
			<th colspan="2">
				<ng-container [ngSwitch]="lang">
					<span *ngSwitchCase="'ar'">المجموع قبل الضريبة</span>
					<span *ngSwitchCase="'he'">סה״כ לפני מס</span>
					<span *ngSwitchDefault>Total Before Tax</span>
				</ng-container>
			</th>
			<th class="value" colspan="2">{{ formatNumber(invoiceData?.amount_before_discount) }}</th>
		</tr>

		<tr>
			<th colspan="2">
				<ng-container [ngSwitch]="lang">
					<span *ngSwitchCase="'ar'">الخصم</span>
					<span *ngSwitchCase="'he'">הנחה</span>
					<span *ngSwitchDefault>Percentage</span>
				</ng-container>
			</th>
			<th class="value" colspan="3">{{ formatNumber(invoiceData?.all_discount) }}</th>
		</tr>

		<tr>
			<th colspan="2">
				<ng-container [ngSwitch]="lang">
					<span *ngSwitchCase="'ar'">الإجمالي للدفع</span>
					<span *ngSwitchCase="'he'">סה״כ לתשלום</span>
					<span *ngSwitchDefault>Total Due</span>
				</ng-container>
			</th>
			<th class="value" colspan="3">{{ formatNumber(getPaymentAmountIncludingVat()) }}</th>
		</tr>
	</table>

	<div *ngIf="invoiceData?.receiptsDetails?.length">
		<h6 style="margin-bottom: 10px;">
			<ng-container [ngSwitch]="lang">
				<span *ngSwitchCase="'en'">Payment Info</span>
				<span *ngSwitchCase="'ar'">بيانات الدفع</span>
				<span *ngSwitchDefault>נתוני תשלום</span>
			</ng-container>
		</h6>
		<table class="table-one">
			<thead>
				<tr>
					<th style="font-weight: 600; font-size: 12px; text-align: start;">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'en'">Payment Method</span>
							<span *ngSwitchCase="'ar'">طرق الدفع</span>
							<span *ngSwitchDefault>אמצעי תשלום</span>
						</ng-container>
					</th>
					<th style="font-weight: 600; font-size: 12px; text-align: start;">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'en'">Date</span>
							<span *ngSwitchCase="'ar'">تاريخ</span>
							<span *ngSwitchDefault>תאריך</span>
						</ng-container>
					</th>
					<th style="font-weight: 600; font-size: 12px; text-align: start;">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'en'">Check Number</span>
							<span *ngSwitchCase="'ar'">رقم الشيك</span>
							<span *ngSwitchDefault>מספר שיק</span>
						</ng-container>
					</th>
					<th style="font-weight: 600; font-size: 12px; text-align: start;">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'en'">Account Number</span>
							<span *ngSwitchCase="'ar'">رقم الحساب</span>
							<span *ngSwitchDefault>מספר חשבון</span>
						</ng-container>
					</th>
					<th style="font-weight: 600; font-size: 12px; text-align: start;">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'en'">Bank</span>
							<span *ngSwitchCase="'ar'">البنك</span>
							<span *ngSwitchDefault>בנק</span>
						</ng-container>
					</th>
					<th style="font-weight: 600; font-size: 12px; text-align: start;">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'en'">Branch</span>
							<span *ngSwitchCase="'ar'">الفرع</span>
							<span *ngSwitchDefault>סניף</span>
						</ng-container>
					</th>
					<th style="font-weight: 600; font-size: 12px; text-align: start;">
						<ng-container [ngSwitch]="lang">
							<span *ngSwitchCase="'en'">Total</span>
							<span *ngSwitchCase="'ar'">المجموع</span>
							<span *ngSwitchDefault>סה"כ</span>
						</ng-container>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let receipt of invoiceData.receiptsDetails">
					<td style="text-align: start;">
						{{ getPaymentMethodName(receipt.payment_type) }}
					</td>
					<td style="text-align: start;">{{ receipt.date }}</td>
					<td style="text-align: start;">{{ receipt.reference }}</td>
					<td style="text-align: start;">{{ receipt.account }}</td>
					<td>{{ getBankName(receipt.bank) || 'N/A' }}</td>
					<td style="text-align: start;">{{ receipt.branch }}</td>
					<td style="text-align: start;">{{ formatNumber(receipt.amount) }}</td>
				</tr>
			</tbody>
		</table>
		<div style="margin-right: auto; margin-left:32px; width:fit-content;">
			<div *ngIf="invoiceData?.deduction_from_source">
				<span>
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'en'">Deduction at source</span>
						<span *ngSwitchCase="'ar'">الخصم من المصدر</span>
						<span *ngSwitchDefault>ניכוי במקור</span>
					</ng-container>:
				</span>
				{{ formatNumber(invoiceData.deduction_from_source) }}
			</div>
			<div style="display:flex; align-items:center; gap:40px">
				<span style="font-size:14px;">
					<ng-container [ngSwitch]="lang">
						<span *ngSwitchCase="'en'">Total</span>
						<span *ngSwitchCase="'ar'">المجموع</span>
						<span *ngSwitchDefault>סה"כ</span>
					</ng-container>:
				</span>
				<span style="font-size:12px; background-color: rgba(0, 255, 255, 0.389);">
					{{ formatNumber(invoiceData?.total_amount) }}
				</span>
			</div>
		</div>
	</div>

	<p *ngIf="invoiceData?.invoice_reference_number">
		<span>
			<ng-container [ngSwitch]="lang">
				<span *ngSwitchCase="'en'">
					Reverse Invoice for Tax Invoice Number: {{ invoiceData.invoice_reference_number }}
				</span>
				<span *ngSwitchCase="'ar'">
					فاتورة عكسية عن فاتورة ضريبية رقم: {{ invoiceData.invoice_reference_number }}
				</span>
				<span *ngSwitchDefault>
					חשבונית ריכוז עבור חשובנית מס: {{ invoiceData.invoice_reference_number }}
				</span>
			</ng-container>
		</span>
	</p>

	<div *ngIf="invoiceData?.note" class="invoice-note"
		 style="margin: 20px auto; padding: 0; text-align: center; color: red; font-size: 16px; font-weight: bold;">
		<p style="margin: 0;">** {{ invoiceData.note }} **</p>
	</div>

	<div *ngIf="invoiceData?.invoice_note" class="invoice-note"
		 style="margin-top: 20px; padding: 10px; border: 1px solid #E0E0E0; border-radius: 5px;">
		<h4 style="font-weight: 600; font-size: 14px;">
			<ng-container [ngSwitch]="lang">
				<span *ngSwitchCase="'en'">Note:</span>
				<span *ngSwitchCase="'ar'">ملاحظة:</span>
				<span *ngSwitchDefault>הערה:</span>
			</ng-container>
		</h4>
		<p style="font-size: 14px; font-weight: 300; margin: 5px 0; white-space: pre-line;">{{ invoiceData.invoice_note | formatNoteHtml }}</p>
	</div>

	<div style="display: flex; justify-content: space-between; align-items: flex-start; margin-top: 20px;">
		<div *ngIf="invoiceData?.showSeal" class="seal-container" style="text-align: right;">
			<img [src]="invoiceData?.seal_base64 || invoiceData?.company?.seal_url" alt="Company Seal">
		</div>

		<div *ngIf="invoiceData?.showSignature" style="text-align: left; margin-right: 20px;">
			<p style="margin: 0; padding: 0; text-align: left;">
				<ng-container [ngSwitch]="lang">
					<span *ngSwitchCase="'en'">signature_____________________</span>
					<span *ngSwitchCase="'ar'">امضاء_____________________</span>
					<span *ngSwitchDefault>חתימה_____________________</span>
				</ng-container>
			</p>

			<div style="margin: 0; padding: 0; text-align: left;">
				<p style="margin: 0; padding: 0; margin-left: 55px; font-size: 14px;">
					{{ getCompanyName() }}
				</p>
				<p style="margin: 0; padding: 0; margin-left: 55px; font-size: 14px;">
					{{ getCompanyVat() }}
				</p>
			</div>
		</div>
	</div>

	<div class="bottom-notes" style="display: flex; justify-content: space-between; direction: ltr;">
		<p *ngIf="invoiceData?.company?.left_note" class="note-left" style="text-align: left;" [innerHTML]="invoiceData.company.left_note"></p>
		<p *ngIf="invoiceData?.company?.right_note" class="note-right" style="text-align: right;" [innerHTML]="invoiceData.company.right_note"></p>
	</div>
</div>
